<template>
  <!-- Need to add height inherit because Vue 2 don't support multiple root ele -->
  <div style="height: inherit" class="custom-chat">
    <div
      class="body-content-overlay"
      :class="{
        show: shallShowActiveChatContactSidebar || mqShallShowLeftSidebar,
      }"
      @click="
        mqShallShowLeftSidebar = shallShowActiveChatContactSidebar = false
      "
    />

    <!-- Main Area -->
    <section class="chat-app-window">
      <!-- Start Chat Logo -->
      <div v-if="!Object.keys(activeChannel).length" class="start-chat-area">
        <div class="mb-1 start-chat-icon">
          <feather-icon icon="MessageSquareIcon" size="56" />
        </div>
        <h4
          class="sidebar-toggle start-chat-text d-lg-none"
          @click="startConversation"
        >
          {{ $t("general.startConversation") }}
        </h4>
        <h4 class="sidebar-toggle start-chat-text d-none d-lg-block">
          {{ $t("general.selectMessageToStartYourConversation") }}
        </h4>
      </div>

      <!-- Chat Content -->
      <div class="active-chat" @keydown="keyCloseConversation">
        <!-- Chat Navbar -->
        <div class="chat-navbar">
          <header class="chat-header">
            <!-- Avatar & Name -->
            <div
              v-if="Object.keys(activeChannel).length"
              class="d-flex align-items-center"
            >
              <b-avatar
                size="36"
                class="mr-1 cursor-pointer badge-minimal"
                variant="light-primary"
                @click.native="shallShowActiveChatContactSidebar = true"
              >
                <img
                  :src="activeChannel.callerUser.avatar"
                  alt="avatar"
                  class="img-avatar"
              /></b-avatar>
              <h6 class="mb-0">
                {{ activeChannel.callerUser.name }}
              </h6>
            </div>

            <!-- Contact Actions -->
            <div class="d-flex align-items-center">
              <feather-icon
                v-if="!mqShallShowRightSidebarCall"
                role="button"
                class="ml-1"
                size="16"
                icon="MenuIcon"
                @click="toggleRightSidebar"
              />
              <feather-icon
                v-else
                role="button"
                class="ml-1"
                size="16"
                icon="XIcon"
                @click="toggleRightSidebar"
              />
            </div>
          </header>

          <div v-if="isTranslate()">
            <div
              v-if="!activeChannel.isAutoTranslate && detectedLanguage"
              class="translateBox bg-primary"
            >
              <div
                class="dropdown chat-filter-dropdown ml-1"
                style="display: flex"
              >
                <div style="padding-top: 4px">
                  {{
                    $t("chat.detectedLanguage", {
                      visitorName: activeChannel.customer.name,
                    })
                  }}
                </div>
                &nbsp;
                <b-dropdown
                  variant="link"
                  no-caret
                  toggle-class="p-0"
                  class="detectLanguage-dropdown"
                >
                  <template #button-content>
                    <flag
                      :iso="getCountryCode(detectedLanguage.language)"
                      :squared="false"
                    />&nbsp;
                    <span class="text-white">{{ detectedLanguage.name }}</span>
                  </template>

                  <b-dropdown-form class="sticky-search">
                    <b-form-group>
                      <b-form-input
                        v-model="textSearch"
                        :placeholder="$t('general.search')"
                        @keydown.enter.prevent
                        @input="searchLocal"
                      />
                    </b-form-group>
                  </b-dropdown-form>

                  <b-dropdown-item
                    v-for="(local, index) in currentLocale"
                    v-if="localFilterSearch == ''"
                    :key="index"
                    @click="changeDetectedLanguage(local)"
                  >
                    <template v-if="local">
                      <flag
                        :style="{ zIndex: -1 }"
                        :iso="getCountryCode(local.language)"
                        :squared="false"
                      />
                      &nbsp;&nbsp;{{ local.name }}
                    </template>
                  </b-dropdown-item>

                  <b-dropdown-item
                    v-for="(local, index) in filteredLocal"
                    v-if="localFilterSearch != ''"
                    :key="index"
                    @click="changeDetectedLanguage(local)"
                  >
                    <template v-if="local">
                      <flag
                        :iso="getCountryCode(local.language)"
                        :squared="false"
                      />
                      &nbsp;&nbsp;{{ local.name }}
                    </template>
                  </b-dropdown-item>
                </b-dropdown>

                &nbsp;
                <b-button
                  class="cursor-pointer btn btn-success btn-sm"
                  :disabled="loading"
                  @click="
                    activeChannel.state == conversationStatus.open
                      ? isAutoTranslate(true)
                      : showAlert()
                  "
                >
                  <span v-if="!loading">{{
                    $t("chat.startLiveTranslate")
                  }}</span>
                  <span v-else>{{ $t("general.loading") }}</span>
                </b-button>
              </div>
            </div>

            <div
              v-if="activeChannel.isAutoTranslate"
              class="bg-primary translateBox"
            >
              <div v-if="operatorLanguage">
                <span
                  v-b-tooltip.hover
                  :title="operatorLanguage.name"
                  style="cursor: pointer"
                >
                  <flag
                    :iso="getCountryCode(operatorLanguage.language)"
                    :squared="false"
                  />&nbsp;
                </span>
                &nbsp;
                <span
                  v-b-tooltip.hover
                  :title="detectedLanguage.name"
                  style="cursor: pointer"
                >
                  <flag
                    :iso="getCountryCode(detectedLanguage.language)"
                    :squared="false"
                  />&nbsp;
                </span>
                {{ $t("chat.liveTranslate") }}&nbsp;
                <b-button
                  class="cursor-pointer btn btn-danger btn-sm"
                  :disabled="loading"
                  @click="
                    activeChannel.state == conversationStatus.close
                      ? showAlert()
                      : isAutoTranslate(false)
                  "
                >
                  <span v-if="!loading">{{ $t("general.stop") }}</span>
                  <span v-else>{{ $t("general.loading") }}</span>
                </b-button>
              </div>
            </div>
          </div>
        </div>

        <!-- User Chat Area -->
        <div class="messages-body">
          <div v-if="!connectionStatus" class="connection-status no-internet">
            <small>{{ $t("chat.noInternet") }}</small>
          </div>
          <div
            ref="refChatLogPS"
            class="user-chats scroll-area overflow-y"
            :class="{
              'pt-2': !connectionStatus,
            }"
            @click="onBodyClick"
            @scroll="handleScrollMessage"
          >
            <div class="infinite-wrapper">
              <infinite-loading
                v-show="messages.length"
                ref="infiniteLoading_prev"
                direction="top"
                :identifier="activeChannel.channel"
                @infinite="listMessage_prev"
              >
                <div slot="spinner">
                  <b-spinner label="Spinning" />
                </div>
                <div slot="no-more" />
                <div slot="no-results" />
              </infinite-loading>
            </div>
            <call-message
              :key="chatBoxKey"
              :active-channel="activeChannel"
              :messages="messages"
              :read-message="activeChannel.readMessage"
              :is-typing="isTyping"
              @retry="retrySendMessage"
              @translate="manualTranslate"
            />
            <div class="infinite-wrapper">
              <infinite-loading
                v-show="messages.length"
                ref="infiniteLoading_next"
                direction="bottom"
                :identifier="activeChannel.channel"
                @infinite="listMessage_next"
              >
                <div slot="spinner">
                  <b-spinner label="Spinning" />
                </div>
                <div slot="no-more" />
                <div slot="no-results" />
              </infinite-loading>
            </div>
          </div>
          <div
            v-if="!hidePullDown"
            class="action-btn pull-down-btn btn-primary rounded-circle"
            @click="fetchLatest"
          >
            <feather-icon icon="ArrowDownCircleIcon" size="40" />
          </div>
        </div>
      </div>
    </section>

    <!-- Sidebar -->
    <portal to="content-renderer-sidebar-left">
      <call-left-sidebar
        :identifier="identifier"
        :channels="channels"
        :active-channel="activeChannel"
        :mq-shall-show-left-sidebar.sync="mqShallShowLeftSidebar"
        :connection-status="connectionStatus"
        @filter="filter"
        @open-chat="openChannel"
        @load-channel="listChannel"
        @closeChannel="closeChannel"
      />
    </portal>
    <portal to="content-renderer-sidebar-right">
      <call-right-sidebar
        :mq-shall-show-right-sidebar.sync="mqShallShowRightSidebarCall"
        :connection-status="connectionStatus"
        :send-text-message="changePreTextMessage"
        :active-channel="activeChannel"
      />
    </portal>
    <load-profile />
  </div>
</template>

<script>
import store from "@/store";
import { ref } from "@vue/composition-api";
import {
  BAvatar,
  BDropdown,
  BDropdownItem,
  BFormInput,
  BButton,
  BSpinner,
  BDropdownForm,
  BFormGroup,
} from "bootstrap-vue";

import { $themeBreakpoints } from "@themeConfig";
import { useResponsiveAppSidebarVisibility } from "@core/comp-functions/ui/app";
import Repository from "@/repositories/RepositoryFactory";
import conversationStatus from "@/data/conversationStatus";
import messageType from "@/data/messageType";
import messageStatus from "@/data/messageStatus";
import languageEn from "@/data/languages/en";
import languageKm from "@/data/languages/km";
import languageZh from "@/data/languages/zh-cn";
import languageVi from "@/data/languages/vi";
import { getCountryByLanguageCode } from "@/libs/helper";
import { v4 as uuidv4 } from "uuid";
import moment from "moment";
import InfiniteLoading from "vue-infinite-loading";
import Client from "@/repositories/Clients/AxiosClient";
import Config from "@/repositories/Clients/AxiosDefaultConfig";
import localeCountries from "@/data/localeCountries";
import useJwt from "@/auth/jwt/useJwt";
import CallRightSidebar from "./CallRightSidebar.vue";
import CallMessage from "./CallMessage.vue";
import CallLeftSidebar from "./CallLeftSidebar.vue";

const ChatChannelRepository = Repository.get("chatChannel");
const ChatMessageRepository = Repository.get("chatMessage");
const TranslateRepository = Repository.get("translateRepository");
const PartnersShipRepository = Repository.get("partnersShip");
const CallCenterRepository = Repository.get("callCenter");

export default {
  components: {
    // BSV
    BAvatar,
    BDropdown,
    BDropdownItem,
    BFormInput,
    BButton,
    BSpinner,
    BDropdownForm,
    BFormGroup,

    // 3rd Party
    InfiniteLoading,

    // SFC
    CallLeftSidebar,
    CallRightSidebar,
    CallMessage,
  },
  data() {
    return {
      channelFilter: {
        state: null,
        search: null,
        operator: null,
        isAuto: null,
        isUnread: null,
        isBlock: null,
        searchType: "m",
        startDate: null,
        endDate: null,
      },
      localFilterSearch: "",
      identifier: 1,
      activeChannel: {},
      channels: [],
      channel: "",
      messages: [],
      message: "",
      channelPerPage: 15,
      channelPage: 1,
      messageLimit: 15,
      isShowEmojiPicker: false,
      shallShowActiveChatContactSidebar: false,
      connectionStatus: true,
      isTyping: false,
      randomKey: null,
      isAutoAssignOperator: false,

      lastSeenMessageId: null,
      lastSeenMessageAt: null,

      conversationStatus,
      messageType,
      messageStatus,
      isModalOpen: false,
      show: false,
      isTranslationOn: null,
      chatBoxKey: 0,
      textSearch: "",
      loading: false,
      hidePullDown: true,
    };
  },
  computed: {
    userData() {
      return this.$store.state.profile.email || this.$store.state.profile.phone  
        ? this.$store.state.profile
        : JSON.parse(
            localStorage.getItem(useJwt.jwtConfig.storageUserDataKeyName)
          );
    },
    isTransfer() {
      if (this.activeChannel.transferred) {
        const transferring = this.activeChannel.transferred.find(
          (e) => !e.endedAt
        );
        if (transferring) {
          return true;
        }
      }
      return false;
    },
    trasferredData() {
      if (this.activeChannel.transferred) {
        return this.activeChannel.transferred.find((e) => !e.endedAt);
      }
      return {};
    },
    profilePicture() {
      if (this.$store.state.profile.profilePicture) {
        return this.$store.state.profile.profilePicture;
      }

      return this.userData.profilePicture;
    },
    detectedLanguage() {
      const data = this.getCountryByLanguageCode(
        this.currentLocale,
        this.activeChannel.detectedLanguage || this.$i18n.locale
      );
      if (data) {
        return data;
      }
      return null;
    },
    operatorLanguage() {
      return getCountryByLanguageCode(
        this.currentLocale,
        this.activeChannel.operatorLanguage
      );
    },
    currentLocale() {
      if (this.$i18n.locale === "km") {
        return this.languageKm;
      } else if (this.$i18n.locale === "en") {
        return this.languageEn;
      } else if (this.$i18n.locale === "vi") {
        return this.languageVi;
      }

      return this.languageZh;
    },
    filteredLocal() {
      let local = [];
      if (this.$i18n.locale === "km") {
        local = this.languageKm;
      } else if (this.$i18n.locale === "en") {
        local = this.languageEn;
      } else if (this.$i18n.locale === "vi") {
        local = this.languageVi;
      } else {
        local = this.languageZh;
      }
      if (this.localFilterSearch.length > 0) {
        local = local.filter((value) => {
          const name = value?.name?.toLowerCase();
          return name.startsWith(this.localFilterSearch.toLowerCase());
        });
      }
      return local;
    },
    isSearchingMessage() {
      return (
        this.channelFilter.searchType == "m" &&
        this.channelFilter.search?.trim()
      );
    },
  },
  watch: {
    connectionStatus(value, oldValue) {
      if (!oldValue && value) {
        this.reloadChannel();
        this.reloadMessage();
      }
    },

    lastSeenMessageId(value, oldValue) {
      if (value && value != oldValue) {
        this.submitReadMessage(
          this.activeChannel?.token,
          value,
          this.lastSeenMessageAt
        );
      }
    },
  },
  mounted() {
    window.addEventListener("chatSettings", (event) => {
      const data = JSON.parse(localStorage.getItem("chatSettings"));
      this.isTranslationOn = data?.isTranslationOn || true;
    });

    window.addEventListener("chatSettings", (event) => {
      const data = JSON.parse(localStorage.getItem("chatSettings"));
      this.isTranslationOn = data?.isTranslationOn || true;
    });

    this.$root.$on("bv::modal::shown", (bvEvent, modalId) => {
      bvEvent.vueTarget.$refs["close-button"]?.setAttribute("tabIndex", "-1");
      bvEvent.vueTarget.$refs["ok-button"]?.focus();
    });
    window.addEventListener("keydown", this.keyCloseConversation);

    this.textSearch = this.localFilterSearch;
  },
  created() {
    window.addEventListener("storage", (evt) => {
      if (evt.key == "chatSettings" && evt.newValue == null) {
        if (localStorage.getItem("chatSettings") == null) {
          localStorage.setItem(
            "chatSettings",
            JSON.stringify(this.userData.chatSettings)
          );
        }
      }
    });
    if (localStorage.getItem("chatSettings") == null) {
      localStorage.setItem(
        "chatSettings",
        JSON.stringify(this.userData.chatSettings)
      );
    }

    this.randomKey = uuidv4();
    if (localStorage.getItem("tabKey") == null) {
      localStorage.setItem("tabKey", this.randomKey);
    }

    const self = this;
    window.addEventListener("beforeunload", () => {
      localStorage.removeItem("tabKey");
    });
    window.addEventListener("storage", (evt) => {
      if (evt.key == "tabKey" && evt.newValue == null) {
        if (localStorage.getItem("tabKey") == null) {
          localStorage.setItem("tabKey", self.randomKey);
        }
      }
    });
  },
  destroyed() {
    window.removeEventListener("keydown", this.keyCloseConversation);
  },
  methods: {
    updateQuerySting() {
      this.$router.replace({ query: this.query });
      this.$nextTick(() => {
        if (this.query.cache != "no") {
          store.commit("app/UPDATE_CALL_QUERY", { ...this.query });
        }
      });
    },
    getCountryCode(language) {
      return this.localeCountries.find(
        (e) => e.language.toLowerCase() === language.toLowerCase()
      ).flag;
    },

    isTranslate() {
      if (this.activeChannel.isAutoTranslate) {
        return true;
      }
      const chatSetting =
        JSON.parse(localStorage.getItem("chatSettings")).isTranslationOn == 1;
      const chatChannel = this.activeChannel.state != 1; // `1` = channel is opening
      const isTransferToMerchant = this.isTransfer;
      const isAsignToOtherOperator =
        this.activeChannel.operatorAssigned != this.userData.id;
      return chatChannel || isTransferToMerchant || isAsignToOtherOperator
        ? false
        : !!chatSetting;
    },
    showAlert() {
      this.$swal.fire({
        text: this.$t("alert.pleaseOpenConversationFirst"),
        icon: "warning",
        confirmButtonText: this.$t("button.close"),
      });
    },
    isAutoTranslate(isAutoTranslate) {
      this.loading = true;
      const payload = {
        token: this.activeChannel.token,
        isAutoTranslate,
        detectedLanguage:
          this.activeChannel?.detectedLanguage || this.$i18n.locale,
      };
      ChatChannelRepository.isAutoTranslate(payload)
        .then((response) => {
          this.loading = false;
          const data = response?.data?.data;
          if (data) {
            this.activeChannel = {
              ...this.activeChannel,
              isAutoTranslate: data.isAutoTranslate,
              detectedLanguage: data.detectedLanguage,
              operatorLanguage: data.operatorLanguage,
            };
          }
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    searchLocal(text) {
      this.localFilterSearch = text;
    },
    changeDetectedLanguage(selectedLang) {
      return (this.activeChannel = {
        ...this.activeChannel,
        detectedLanguage: selectedLang.language,
      });
    },
    changePreTextMessage(text) {
      this.$refs.chatInput.text = text;
      this.$refs.chatInput.$refs.inputBox?.$el?.focus();
    },
    toggleRightSidebar() {
      console.log("toggle ");
      this.mqShallShowRightSidebarCall = !this.mqShallShowRightSidebarCall;
      this.preTextMessage = "";
    },
    synceChannel(data) {
      const channel = data.data;
      if (
        this.channelFilter.state &&
        channel.state != this.channelFilter.state
      ) {
        return;
      }
      if (
        this.channelFilter.search &&
        !this.isSearchingMessage &&
        channel.name.indexOf(this.channelFilter.search) == -1
      ) {
        return;
      }
      if (
        this.isSearchingMessage &&
        channel.latestMessage?.message.indexOf(this.channelFilter.search) == -1
      ) {
        return;
      }
      if (
        this.channelFilter.operator &&
        channel.operatorAssigned != this.channelFilter.operator
      ) {
        return;
      }
      if (this.channelFilter.type == "unassign" && channel.operatorAssigned) {
        return;
      }

      return true;
    },

    removeChannel(index) {
      if (index != -1) {
        this.channels.splice(index, 1);
        return true;
      }
    },

    toUtc(dateStr, hours = 0) {
      const date = new Date(dateStr);
      if (hours > 0) {
        date.setHours(date.getHours() + hours);
      }
      const utcDate = new Date(
        Date.UTC(
          date.getFullYear(),
          date.getMonth(),
          date.getDate(),
          date.getHours(),
          date.getMinutes(),
          date.getSeconds()
        )
      );
      return utcDate;
    },

    addHours(dateStr, hours = 0) {
      const date = new Date(dateStr);
      if (hours > 0) {
        date.setHours(date.getHours() + hours);
      }
      return date;
    },

    filter(query) {
      let state = null;
      let isUnread = null;
      let isBlock = null;
      if (query.filter == "unresolved") {
        state = 1;
      } else if (query.filter == "resolved") {
        state = 2;
      } else if (query.filter == "unread") {
        isUnread = 1;
      } else if (query.filter == "banned") {
        isBlock = 1;
      }

      let type = "";
      let operator = null;
      if (query.type == "assignToMe") {
        operator = this.userData.id;
      } else if (query.type == "unassign") {
        type = "unassign";
      } else if (query.operator) {
        operator = query.operator;
      }

      const search = query.search ? query.search : null;

      this.channelFilter.state = state;
      this.channelFilter.search = search;
      this.channelFilter.operator = operator;
      this.channelFilter.type = type;
      this.channelFilter.isUnread = isUnread;
      this.channelFilter.isBlock = isBlock;
      this.channelFilter.searchType = query.searchType;
      this.channelFilter.startDate = moment(query.startDate)
        .startOf("day")
        .toISOString();
      this.channelFilter.endDate = query.endDate
        ? moment(query.endDate).endOf("day").toISOString()
        : null;
      this.channelFilter.status = query.status;

      this.channels = [];
      this.channelPage = 1;
      this.identifier++;

      if (query.channel) {
        this.loadActiveChannel(query.channel);
      }
    },
    loadActiveChannel(channelId) {
      CallCenterRepository.session
        .detail({
          id: channelId,
        })
        .then((response) => {
          const data = response?.data?.data;
          if (data) {
            this.openChannel({ ...data });
          }
        });
    },
    async reloadChannel() {
      const date = this.channels[0] ? this.channels[0].updatedAt : "";
      if (date) {
        ChatChannelRepository.latest({
          order: "updatedAt",
          sort: "ASC",
          date,
          ...this.channelFilter,
          startDate: moment(this.channelFilter.startDate)
            .startOf("day")
            .toISOString(),
          endDate: moment(this.channelFilter.endDate)
            .endOf("day")
            .toISOString(),
        })
          .then((response) => {
            const data = response?.data?.data?.list;
            if (data) {
              data.forEach((element) => {
                const index = this.channels.findIndex(
                  (channel) => channel.channel == element.channel
                );
                if (index != -1) {
                  this.channels.splice(index, 1);
                }

                this.channels.unshift(element);

                if (this.activeChannel.channel == element.channel) {
                  this.activeChannel = {
                    ...element,
                  };
                }
              });
            }
          })
          .catch((error) => {});
      } else {
        this.listChannel();
      }
    },
    async listChannel($state = null) {
      CallCenterRepository.session
        .index({
          limit: this.channelPerPage,
          page: this.channelPage,
          order: "updatedAt",
          ...this.channelFilter,
          startDate: moment(this.channelFilter.startDate)
            .startOf("day")
            .toISOString(),
          endDate: moment(this.channelFilter.endDate)
            .endOf("day")
            .toISOString(),
        })
        .then((response) => {
          this.channelPage++;

          const data = response?.data?.data;
          if (data) {
            this.channels = [...this.channels, ...data.list];

            if (this.$route.query.channel) {
              const { channel } = this.$route.query;
              const selectedExist = this.channels.find(
                (val) => val.id == channel
              );

              if (!selectedExist && this.$route.query.filter != "") {
                this.activeChannel.channel = null; // force no slected channel
              }
            }

            if ($state && data.list == 0) {
              $state.complete();
            }
          }
        })
        .catch()
        .then(() => {
          if ($state) {
            $state.loaded();
          }
        });
    },
    reloadMessage() {
      const date = this.messages[this.messages.length - 1]
        ? this.messages[this.messages.length - 1].createdAt
        : "";
      ChatMessageRepository.latest({
        channel: this.activeChannel.channel,
        date,
      })
        .then((response) => {
          const data = response?.data?.data;
          if (data) {
            data.reverse();
            data.forEach((element) => {
              this.messages.push(element);
            });
            this.$nextTick(() => {
              this.scrollToBottom();
            });
          }
        })
        .catch((error) => {});
    },
    closeChannel() {
      this.activeChannel = {};
    },
    keyCloseConversation(event) {
      if (!this.isModalOpen) {
        if (
          this.activeChannel.state == this.conversationStatus.open &&
          !this.activeChannel.blockAt &&
          this.activeChannel.operatorAssigned == this.userData.id
        ) {
          if (event.ctrlKey && event.key === "F2") {
            this.confirmResolve(this.conversationStatus.close);
          }
        }
      }
    },
    handleScrollMessage(e) {
      const el = e.target;
      const distance = el.scrollHeight - (el.scrollTop + el.offsetHeight);
      if (distance <= 100) {
        this.hidePullDown = true;
      } else if (this.hidePullDown) {
        this.hidePullDown = false;
      }
    },
    fetchLatest() {
      this.scrollToBottom("smooth");
      // Proceed when infinite scroll not yet done.
      if (this.$refs.infiniteLoading_next.status != 2) {
        // Needed to complete next scroll. Prevent unstop fetching.
        // this.$refs.infiniteLoading_next.stateChanger.complete();
        // Fetch latest messages.
        this.listMessage(null, null, true, true);
      }
    },
    listMessage_prev($state) {
      this.listMessage($state, this.messages[0].createdAt);
    },
    listMessage_next($state) {
      this.listMessage(
        $state,
        this.messages[this.messages.length - 1].createdAt,
        false
      );
    },
    listMessage(
      $state = null,
      date = null,
      reverse = true,
      fetchLatest = false,
      channel = null
    ) {
      const query = {};

      if (date) {
        if (reverse) {
          query.lte = date;
        } else {
          query.gte = date;
        }
      }

      ChatMessageRepository.index({
        channel: channel || this.activeChannel.channel,
        limit: this.messageLimit,
        offset: 0, // always 0
        ...query,
      })
        .then((response) => {
          const data = response?.data?.data;

          if (data) {
            let isScrollBottom = true;
            if (fetchLatest) {
              this.messages = [];
              // Needed to reset prev scroll
              // this.$refs.infiniteLoading_prev.stateChanger.reset();
            } else {
              isScrollBottom = this.messages.length == 0;
            }
            this.$nextTick(() => {
              data.forEach((element) => {
                if (element.chatChannelId == this.activeChannel.id) {
                  const isExist = this.messages.findIndex(
                    (message) => message.ref == element.ref
                  );
                  if (isExist == -1) {
                    if (reverse) {
                      this.messages.unshift(element);
                    } else {
                      this.messages.push(element);
                    }
                  }
                }
              });
            });

            if ($state && data.length < this.messageLimit) {
              $state.complete();
            }

            if (isScrollBottom) {
              this.$nextTick(() => {
                setTimeout(() => {
                  this.scrollToBottom();
                }, 100);
              });
            }
          }
        })
        .catch()
        .then(() => {
          if ($state) {
            $state.loaded();
          }
        });
    },
    openChannel(channel) {
      this.isTyping = false;
      this.activeChannel = channel;
      this.mqShallShowLeftSidebar = false;
      this.messages = [];

      switch (this.channelFilter.searchType) {
        case "c":
          this.listMessage();
          break;

        case "m":
          const message = this.activeChannel.latestMessage;
          const { channel } = this.activeChannel;
          break;

        default:
          break;
      }
    },
    sendTextMessage(message, translate) {
      if (!message) {
        return;
      }

      this.$refs.chatInput.typing(false);

      const data = {
        ref: uuidv4(),
        createdAt: moment(),
        message,
        messageType: this.messageType.text,
        token: this.activeChannel.token,
      };

      this.sendMessage(data, translate);
    },
    sendAttachmentMessage(message) {
      if (!message.file) {
        return;
      }
      this.$refs.chatInput.typing(false);

      const data = {
        ref: uuidv4(),
        createdAt: moment(),
        file: message.file,
        message: message.fileName,
        mediaUrl: message.fileUrl,
        messageType: this.messageType.attachment,
        token: this.activeChannel.token,
      };

      this.sendMessage(data);
    },
    retrySendMessage(index) {
      if (this.activeChannel.state != this.conversationStatus.open) {
        return;
      }
      const message = this.messages[index];
      this.messages.splice(index, 1);
      this.sendMessage(message);
    },
    manualTranslate(index) {
      const message = this.messages[index];
      const target = this.$i18n.locale;
      TranslateRepository.translate({ text: message.message, target }).then(
        (response) => {
          this.messages[index].translatedMessage =
            response?.data?.data?.translatedMessage;
          this.messages[index].translatedLanguage =
            response?.data?.data?.translatedLanguage;
          this.messages[index].detectedLanguage =
            response?.data?.data?.detectedLanguage;

          this.chatBoxKey += 1;
        }
      );
    },
    async uploadImage(message) {
      const formData = new FormData();
      formData.append("image", message.file);

      const response = await Client.post(
        `${Config.basePath}/upload/file`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          onUploadProgress: function (progressEvent) {
            const index = this.messages.findIndex(
              (element) => element.ref == message.ref
            );
            if (index != -1) {
              this.messages[index].uploadPercentage = parseInt(
                Math.round((progressEvent.loaded / progressEvent.total) * 100)
              );
            }
          }.bind(this),
        },
        {
          timeout: 10000000,
        }
      );

      const mediaId = response?.data?.data?.mediaId;
      if (mediaId) {
        return mediaId;
      }
      const index = this.messages.findIndex(
        (element) => element.ref == message.ref
      );
      if (index != -1) {
        this.messages[index].sentStatus = messageStatus.fail;
      }
      return false;
    },
    async sendMessage(message, translate) {
      const newMessage = {
        ...message,
        translatedMessage: translate?.translatedMessage,
        translatedLanguage: translate?.translatedLanguage,
        detectedLanguage: translate?.detectedLanguage,
        uploadPercentage: 0,
        participant: {
          participantType: "merchant",
          id: this.userData.id,
        },
        profileUrl: this.profilePicture,
        sentStatus: this.messageStatus.sending,
      };

      this.messages.push(newMessage);

      this.$nextTick(() => {
        if (this.$refs.infiniteLoading_next.status == 2) {
          this.scrollToBottom("smooth");
        }
      });

      if (message.file) {
        const mediaId = await this.uploadImage(message);
        if (!mediaId) {
          return;
        }

        message.mediaId = mediaId;
      }

      ChatMessageRepository.create({
        message: message.message,
        messageType: message.messageType,
        mediaId: message.mediaId,
        ref: message.ref,
        token: message.token || this.activeChannel.token,
      })
        .then((response) => {
          const data = response?.data?.data;
          if (data) {
            const index = this.messages.findIndex(
              (element) => element.ref == message.ref
            );

            if (index != -1) {
              this.messages[index].id = data.id;
              this.messages[index].createdAt = data.createdAt;
              this.messages[index].sentStatus = this.messageStatus.sent;
              this.messages[index].mediaUrl = data.mediaUrl;
            }

            // if it's jumping
            if (this.$refs.infiniteLoading_next.status != 2) {
              this.fetchLatest(newMessage);
            }
          }
        })
        .catch((error) => {
          const index = this.messages.findIndex(
            (element) => element.ref == message.ref
          );
          if (index != -1) {
            this.messages[index].sentStatus = this.messageStatus.fail;
          }
        });
    },
    getChannelStateVariant(state) {
      if (state == this.conversationStatus.open) {
        return "primary";
      }
      if (state == this.conversationStatus.close) {
        return "success";
      }

      return "danger";
    },
    assignOperator() {
      this.$refs.assignOperatorModal.show(
        this.activeChannel.token,
        !!this.activeChannel.operatorAssigned
      );
    },
    transferToOtherMerchant() {
      const channelToken = this.activeChannel.token;
      PartnersShipRepository.show()
        .then((response) => {
          const { data } = response.data;
          const partnerShip = [...data.list];
          if (partnerShip && partnerShip.length >= 1) {
            this.$refs.assignMerchantModal.show(
              channelToken,
              !!this.activeChannel.operatorAssigned
            );
          } else {
            this.$swal.fire({
              text: this.$t("alert.pleaseAskAdminToBindAccount"),
              icon: "warning",
              confirmButtonText: this.$t("button.close"),
            });
          }
        })
        .catch();
    },
    confirmResolve(state) {
      this.isModalOpen = true;
      this.$bvModal
        .msgBoxConfirm(this.$t("alert.areYouSureToResolve"), {
          title: this.$t("alert.areYouSure"),
          size: "sm",
          buttonSize: "sm",
          okVariant: "primary",
          okTitle: this.$t("chat.markAsResolve"),
          cancelTitle: this.$t("button.cancel"),
          cancelVariant: "outline-secondary",
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          if (value) {
            this.updateStatus(state);
          } else {
            this.isModalOpen = false;
          }
        });
    },
    confirmOpen(state) {
      this.$bvModal
        .msgBoxConfirm(this.$t("alert.areYouSureToOpen"), {
          title: this.$t("alert.areYouSure"),
          size: "sm",
          buttonSize: "sm",
          okVariant: "primary",
          okTitle: this.$t("button.openConversation"),
          cancelTitle: this.$t("button.cancel"),
          cancelVariant: "outline-secondary",
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          if (value) {
            this.fetchLatest();
            this.updateStatus(state);
          }
        });
    },
    confirmBan() {
      this.$bvModal
        .msgBoxConfirm(this.$t("alert.areYouSureToBan"), {
          title: this.$t("alert.areYouSure"),
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: this.$t("chat.banThisCustomer"),
          cancelTitle: this.$t("button.cancel"),
          cancelVariant: "outline-secondary",
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          if (value) {
            this.block();
          }
        });
    },
    block() {
      const data = {
        token: this.activeChannel.token,
      };
      ChatChannelRepository.block(data)
        .then((response) => {
          const data = response?.data?.data;
          if (data) {
            this.activeChannel = {
              ...data,
            };
          }
        })
        .then((error) => {});
    },
    confirmUnban() {
      this.$bvModal
        .msgBoxConfirm(this.$t("alert.areYouSureToUnban"), {
          title: this.$t("alert.areYouSure"),
          size: "sm",
          buttonSize: "sm",
          okVariant: "primary",
          okTitle: this.$t("chat.unbanThisCustomer"),
          cancelTitle: this.$t("button.cancel"),
          cancelVariant: "outline-secondary",
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          if (value) {
            this.unblock();
          }
        });
    },
    unblock() {
      const data = {
        token: this.activeChannel.token,
      };
      ChatChannelRepository.unblock(data)
        .then((response) => {
          const data = response?.data?.data;
          if (data) {
            this.activeChannel = {
              ...data,
            };
          }
        })
        .then((error) => {});
    },
    updateStatus(state) {
      // at stop translate at here
      const data = {
        state,
        token: this.activeChannel.token,
      };
      ChatChannelRepository.updateStatus(data)
        .then((response) => {
          const data = response?.data?.data;
          if (data && !this.isSearchingMessage) {
            this.activeChannel = {
              ...data,
            };
          }
        })
        .then((error) => {
          this.isModalOpen = false;
        });
    },
    submitReadMessage(token, messageId, readAt) {
      if (!token || !messageId || !readAt) {
        return;
      }

      ChatMessageRepository.seen({
        token,
        messageId,
        readAt,
      })
        .then((response) => {})
        .catch((err) => {});
    },
    autoAssignToOperator() {
      if (this.activeChannel.operatorAssigned) {
        return;
      }

      ChatChannelRepository.assign({
        token: this.activeChannel.token,
        userId: this.userData.id,
      })
        .then((response) => {
          this.hide();
          this.$emit("success");
        })
        .catch((error) => {
          if (error.response?.status == 422) {
            this.$refs.assignOperatorForm.setErrors(
              error.response?.data?.validate
            );
          }
        })
        .then(() => {
          this.loading = false;
        });
    },
    onBodyClick() {
      if (this.$refs.chatInput) {
        this.$refs.chatInput.closeEmoji();
      }
    },
  },
  setup() {
    // Scroll to Bottom ChatLog
    const refChatLogPS = ref(null);
    const scrollToBottom = (behavior = "instant") => {
      const scrollEl = refChatLogPS.value?.$el || refChatLogPS.value;
      scrollEl.scrollTo({ top: scrollEl.scrollHeight, behavior });
    };

    // UI + SM Devices
    // Left Sidebar Responsiveness
    const { mqShallShowLeftSidebar, mqShallShowRightSidebarCall } =
      useResponsiveAppSidebarVisibility();
    const startConversation = () => {
      if (store.state.app.windowWidth < $themeBreakpoints.lg) {
        mqShallShowLeftSidebar.value = true;
      }
    };

    return {
      refChatLogPS,
      scrollToBottom,
      languageEn,
      languageKm,
      languageZh,
      languageVi,
      localeCountries,
      getCountryByLanguageCode,
      // UI + SM Devices
      startConversation,
      mqShallShowLeftSidebar,
      mqShallShowRightSidebarCall,
    };
  },
};
</script>

<style lang="scss">
@import "~@core/scss/base/pages/app-chat.scss";
@import "~@core/scss/base/pages/app-chat-list.scss";

.detectLanguage-dropdown .dropdown-menu {
  max-height: 300px;
  overflow-y: auto;
}

.sticky-search {
  position: sticky;
  top: 0;
}

.flag {
  font-size: 18px;
}

.translateBox {
  color: #fff;
  padding: 5px;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
  align-content: center;
}

.img-avatar {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>
